
import moment from 'moment';

import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
} from 'vue';

import PrimeVueSidebar from 'primevue/sidebar';

import PrimeVueCalendar from 'primevue/calendar';

import {
  ENTRIES,
  PRESELECTED_PROJECTS_IDS,
} from '@/libs/consts';

import useEntriesNext from '@/composable/useEntries@next';

import type {
  Option,
  Projects,
  Countries,
  ChainsDiffs,
} from '@/types';

export default defineComponent({
  components: {
    PrimeVueSidebar,
    PrimeVueCalendar,
  },
  setup() {
    const {
      entries: projects,
      entriesLoading: projectsLoading,
      fetchEntries: fetchProjects,
    } = useEntriesNext<Projects>('/api/project/getProjects', ENTRIES);

    const {
      entries: countries,
      entriesLoading: countriesLoading,
      fetchEntries: fetchCountries,
    } = useEntriesNext<Countries>('/api/country/getCountries', ENTRIES);

    const {
      entries: chainsDiff,
      entriesLoading: chainsDiffLoading,
      entriesFetched: chainsDiffFetched,
      fetchEntries: fetchchainsDiff,
    } = useEntriesNext<ChainsDiffs>('/api/chain-diff ', ENTRIES);

    const showFilters = ref(false);

    const filtersDateFrom = moment().subtract(7, 'days');

    const filtersDateTo = moment().subtract(1, 'days');

    const filters = reactive({
      date_from: filtersDateFrom.format('YYYY-MM-DD'),
      date_to: filtersDateTo.format('YYYY-MM-DD'),
      project_id: PRESELECTED_PROJECTS_IDS,
      endpoint_id: [],
      country_id: null,
      feed_id: [],
      column_name: [
        'endpoint_id',
        'feed_id',
      ],
    });

    const endpointsParams = computed(() => ({
      include: 'project,user',
      'filter[project_id]': filters.project_id.join(','),
    }));

    const feedsParams = computed(() => ({
      include: 'project',
      'filter[project_id]': filters.project_id.join(','),
    }));

    const filtersDatePeriod = ref([
      filtersDateFrom.toDate(),
      filtersDateTo.toDate(),
    ]);

    const fetchchainsDiffWrapper = async (): Promise<void> => fetchchainsDiff(filters);

    const onFiltersDatePeriodChange = (value: Date[]): void => {
      filters.date_from = moment(value[0]).format('YYYY-MM-DD');

      filters.date_to = moment(value[1]).format('YYYY-MM-DD');
    };

    const onProjectChange = (): void => {
      filters.endpoint_id = [];

      filters.feed_id = [];
    };

    const columnNameOptions : Option[] = [
      {
        value: 'endpoint_id',
        label: 'Endpoint ID',
      },
      {
        value: 'feed_id',
        label: 'Feed ID',
      },
      {
        value: 'country_id',
        label: 'Country 🌍',
      },
    ];

    onMounted(() => Promise.all([
      fetchProjects(),
      fetchCountries(),
      fetchchainsDiffWrapper(),
    ]));

    return {
      projects,
      projectsLoading,
      countries,
      countriesLoading,
      chainsDiff,
      chainsDiffLoading,
      chainsDiffFetched,
      fetchchainsDiffWrapper,
      showFilters,
      filters,
      endpointsParams,
      feedsParams,
      filtersDatePeriod,
      onFiltersDatePeriodChange,
      onProjectChange,
      columnNameOptions,
    };
  },
});
